
import { withInstall } from "../../utils/install";
import APopover from "./src/main.vue";
APopover.name = "ltAPopover";
export const ltAPopover = withInstall(APopover);
export default ltAPopover;

